export default __webpack_public_path__ + "static/8-9b77ae4db6d25bca3684c9607b670346.png";